import {GeneralTypeModel} from '../models/general-type.model';
import {ReminderLogStatusEnum} from './reminder-log-status.enum';

export enum ReminderLogReadStatusEnum {
  Unread = 0,
  Read = 1
}

export function reminderLogReadStatusEnumToGeneralTypeModel(type: ReminderLogReadStatusEnum | null): GeneralTypeModel {
  switch (type) {
    case ReminderLogReadStatusEnum.Unread:
      return { name: 'Unread', color: '#aab900'};
    case ReminderLogReadStatusEnum.Read:
      return { name: 'Read', color: '#00a798'};
    default:
      return { name: 'Unknown', color: '#7b7b7b'};
  }
}
